import React, { memo } from 'react';
import { Command } from 'cmdk';
import { ScrollArea } from './scroll-area';
import PropTypes from 'prop-types';

function SearchSuggestions({ 
  suggestions, 
  history, 
  isLoading, 
  onSelect, 
  onClearHistory 
}) {
  if (!suggestions?.length && !history?.length && !isLoading) {
    return (
      <div role="alert" className="p-4 text-center text-muted-foreground">
        No suggestions available.
      </div>
    );
  }

  return (
    <Command
      className="absolute top-full left-0 w-full mt-2 bg-background rounded-lg border shadow-md overflow-hidden z-50"
      aria-label="Search suggestions"
    >
      <ScrollArea className="max-h-80">
        {isLoading ? (
          <div
            role="status"
            aria-live="polite"
            className="p-4 text-center text-muted-foreground"
          >
            <span className="sr-only">Loading suggestions...</span>
            <span aria-hidden="true">Loading suggestions...</span>
          </div>
        ) : (
          <>
            {history?.length > 0 && (
              <Command.Group heading="Recent Searches">
                {history.map((item, index) => (
                  <Command.Item
                    key={`history-${index}`}
                    value={item}
                    onSelect={onSelect}
                    className="px-4 py-2 hover:bg-accent cursor-pointer flex items-center justify-between"
                  >
                    <span>{item}</span>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onClearHistory(item);
                      }}
                      className="text-sm text-muted-foreground hover:text-foreground"
                      aria-label={`Remove ${item} from history`}
                    >
                      ×
                    </button>
                  </Command.Item>
                ))}
              </Command.Group>
            )}
            {suggestions?.length > 0 && (
              <Command.Group heading="Suggestions">
                {suggestions.map((suggestion, index) => (
                  <Command.Item
                    key={`suggestion-${index}`}
                    value={suggestion}
                    onSelect={onSelect}
                    className="px-4 py-2 hover:bg-accent cursor-pointer"
                  >
                    {suggestion}
                  </Command.Item>
                ))}
              </Command.Group>
            )}
          </>
        )}
      </ScrollArea>
    </Command>
  );
}

SearchSuggestions.propTypes = {
  suggestions: PropTypes.arrayOf(PropTypes.string),
  history:     PropTypes.arrayOf(PropTypes.string),
  isLoading:   PropTypes.bool,
  onSelect:    PropTypes.func.isRequired,
  onClearHistory: PropTypes.func.isRequired
};

const MemoizedSearchSuggestions = memo(SearchSuggestions);
export { MemoizedSearchSuggestions as SearchSuggestions };
export default MemoizedSearchSuggestions;
